var map = {
	"./angular.png": 2673,
	"./bootstrap.png": 9865,
	"./cpp.png": 2121,
	"./csharp.png": 5601,
	"./css.png": 3277,
	"./database.png": 1036,
	"./django.png": 8001,
	"./figma.png": 1805,
	"./gaming.png": 4829,
	"./github.png": 2980,
	"./golang.png": 3549,
	"./graphql.png": 1731,
	"./html.png": 9475,
	"./javascript.png": 6860,
	"./mongodb.png": 4412,
	"./mui.png": 156,
	"./nodejs.png": 9463,
	"./python.png": 8533,
	"./react.png": 8827,
	"./redux.png": 4108,
	"./rust.png": 7508,
	"./sass.png": 6496,
	"./solidity.png": 8637,
	"./tailwind-css.png": 6156,
	"./typescript.png": 7082,
	"./unity.png": 371,
	"./vscode.png": 6123,
	"./vue.png": 1127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4266;